import classNames from 'classnames'
import { Link as RouterLink, type LinkProps } from 'react-router-dom'

type PropTypes = LinkProps

const Link = ({ children, className, ...rest }: PropTypes) => {
  return (
    <RouterLink
      className={classNames(
        'font-semibold leading-[18.2px] outline-none',
        'focus-visible:ring-2 focus-visible:ring-primary-200',
        className,
      )}
      {...rest}
    >
      {children}
    </RouterLink>
  )
}

export default Link
